<template>
  <div>
    <div v-if="!flag.deliveried">
      <p>この度は「{{ helper.master.products.plans[selectedCourse]?.label }}」を申し込みしていただきありがとうございます。</p>
      <p>現在、桐生タイムス紙面をご契約いただいていますか？</p>
      <Spacer :y="3" />
      <div :class="styleClasses.btns">
        <button
          :class="[styleClasses.btn, styleClasses.primary]"
          @click="flag.deliveried = true">はい</button>
        <button
          :class="[styleClasses.btn, styleClasses.primary]"
          @click="toNext()">いいえ</button>
      </div>
    </div>
    <div v-else>
      <p>以前より桐生タイムス紙面をご契約のお客様はこちらで既存の契約の解約をしていただくことが可能です。</p>

      <ul :class="[s.cancel_options]">
        <li
          @click="cancelType = type"
          v-for="type in cancelTypes" :key="type"
          class="mt-3">
          <div :class="s.cancel_radio">
            <input type="radio" name="cancel" :checked="cancelType === type" v-if="selectedCourse !== 'webPaper'" />
            <span v-if="selectedCourse === 'paper'">{{ type === 'cancel' ? '支払い方法を変更する' : '既存契約を解約せず、新たに紙面を契約する' }}</span>
            <span v-else>既存契約を解約{{ type === 'cancel' ? 'する' : 'しない' }}</span>
          </div>
          <div :class="s.cancel_images">
            <div :class="[s.flex_column, s.plan]">
              <i class="fa-solid fa-newspaper" />
              <div :class="s.cancel_plan_label">紙面配達</div>
              <div :class="s.cancel_payment">集金など</div>
            </div>
            <div :class="s.cancel_arrow"><i class="fa-solid fa-arrow-right" /></div>
            <div :class="s.new_plan">
              <div :class="[type === 'cancel' && s.canceled, s.flex_column, s.plan]">
                <i class="fa-solid fa-newspaper" />
                <div :class="s.cancel_plan_label">紙面配達</div>
                <div :class="s.cancel_payment">集金など</div>
              </div>
              <div :class="[s.flex_column, s.plan]">
                <div :class="s.digital">
                  <div :class="s.flex_column"  v-if="selectedCourse.toLowerCase().includes('paper')">
                    <i class="fa-solid fa-newspaper" />
                    <div :class="s.cancel_plan_label">紙面配達</div>
                  </div>
                  <i class="fa-solid fa-plus" v-if="selectedCourse === 'webPaper'"/>
                  <div :class="s.flex_column" v-if="selectedCourse.toLowerCase().includes('web')">
                    <i class="fa-solid fa-mobile-notch" />
                    <div :class="s.cancel_plan_label">電子版</div>
                  </div>
                </div>
                <div :class="s.cancel_payment">クレジットカード</div>
              </div>
            </div>
          </div>
          <div :class="s.note">
            <div v-if="selectedCourse === 'web'">
              <span v-if="type === 'cancel'">既存の紙面配達がなくなり電子版のみとなります。</span>
              <span v-else>既存の紙面配達はそのままで、電子版でもご覧いただけるようになります。<br>紙面配達・電子版どちらも購読される場合、「桐生タイムス電子版＋紙面配達」プランの方がお安くお得です。</span>
            </div>
            <div v-if="selectedCourse === 'webPaper'">
              <span v-if="type === 'cancel'">引き続き紙面は配達されます。<br>加えて、電子版もご利用いただけるようになります。</span>
              <span v-else>既存の購読料金に加えて新たに費用が発生します。<br>既存の契約と新規の契約で紙面が２部配達されます。</span>
            </div>
            <div v-if="selectedCourse === 'paper'">
              <span v-if="type === 'cancel'">お支払い方法が変更となります。</span>
              <span v-else>既存の購読料金に加えて新たに費用が発生します。<br>既存の契約と新規の契約で紙面が２部配達されます。<br>ご家庭と事業所で請求先を分けて購読したい場合におすすめです。</span>
            </div>
          </div>
          <div v-if="selectedCourse === 'webPaper' && type === 'cancel'" class="mt-3" :class="s.cancel_confirm">
            <p class="text-center">このように変更となります。</p>
            <div class="d-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                id="stopCheckbox"
                v-model="flag.cancelConfirm">
              <label for="stopCheckbox" class="ms-2 fw-bold">確認しました</label>
            </div>
          </div>

          <button
            :class="s.btn"
            v-if="selectedCourse === 'web' && type !== 'cancel'"
            @click.stop="changePlan('webPaper')">「桐生タイムス電子版＋紙面配達」<br class="onlySp">に変更する</button>
        </li>
      </ul>

      <div v-if="cancelType === 'cancel'">
        <Spacer :y="6"/>
        <div class="mb-4">既存の紙面配達契約に関する以下の情報をご入力ください。</div>
        <div
          :class="s.stop_form">
          <div :class="s.stop_input">
            <p :class="s.stop_label">契約者氏名</p>
            <input
              id="plusPlanName"
              type="text"
              name="plusPlanName"
              v-model="values.name">
            <span class="slide-in"></span>
            <Spacer :y="6"/>
            <p :class="s.stop_label">契約者住所</p>
            <input
              id="plusPlanAddress"
              type="text"
              name="plusPlanAddress"
              v-model="values.address">
            <span class="slide-in"></span>
            <Spacer :y="6"/>
            <p :class="s.stop_label">契約者電話番号</p>
            <input
              id="plusPlanTel"
              type="text"
              name="plusPlanTel"
              v-model="values.tel">
            <Spacer :y="6"/>
            <p :class="s.stop_label">現在の支払い方法</p>
            <ul
              class="select-list mt-2 category"
              :class="s.radio_wrap">
              <li
                v-for="(method) in paymentMethods"
                :key="method.name"
                :class="s.radio">
                <input
                  type="radio"
                  :name="method.label"
                  :id="method.label"
                  :value="method.label"
                  v-model="values.method"
                  style="display: none">
                <label
                  :for="method.label"
                  :class="[s.radio_label, values.method === method.label ? s.checked : '']">{{ method.label }}</label>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Spacer :y="6"/>
      <div :class="styleClasses.btns">
        <button
          :class="[styleClasses.btn, styleClasses.secondary]"
          @click="toBack()">戻る</button>
        <button
          :class="[
            styleClasses.btn,
            styleClasses.primary,
          ]"
          @click="toNext()"
          :disabled="!readySubmit">次に進む</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Spacer from '@/components/Spacer.vue';

export default {
  name: 'edit-subscription-cancel-exists',
  components: {
    Spacer,
  },
  props: {
    selectedCourse: String || null,
    customerDefaultSource: Object || null,
    deliveryAddress: Object || null,
    styleClasses: Object,
    courseData: Object || null,
    cancelData: Object,
  },
  data() {
    return {
      flag: {
        deliveried: false,
        cancelConfirm: false,
      },
      cancelType: null,
      values: {},
      paymentMethods: [
        {
          name: 'bank',
          label: '銀行引き落とし',
        },
        {
          name: 'collection',
          label: '集金',
        },
        {
          name: 'other',
          label: 'その他',
        },
        {
          name: 'unknown',
          label: '不明',
        },
      ],
    };
  },
  created() {
    this.values = this.cancelData || this.initCancelValue;
    if (!this.selectedCourse) this.toBack();
  },
  computed: {
    ...mapState(['user', 'helper']),
    initCancelValue() {
      return {
        name: '',
        address: '',
        tel: '',
        method: '',
      };
    },
    readySubmit() {
      const isCancel = this.cancelType === 'cancel';
      const isFilled = Object.keys(this.values).every((column) => {
        if (column === 'tel') return Boolean(this.replaceHalfWidthNum(this.values[column]));
        return this.values[column] && !this.values[column].match(/^[ 　\r\n\t]*$/);
      });
      const isConfirmCancel = this.flag.cancelConfirm || this.selectedCourse !== 'webPaper';
      return this.cancelType && (!isCancel || isFilled) && isConfirmCancel;
    },
    cancelTypes() {
      if (this.selectedCourse === 'webPaper') {
        return ['cancel'];
      }
      return ['cancel', 'continue'];
    },
  },
  watch: {
    'flag.deliveried': {
      handler(newVal) {
        if (newVal && this.selectedCourse === 'webPaper') this.cancelType = 'cancel';
      },
    },
  },
  methods: {
    replaceHalfWidthNum(str) {
      // 全角数字 → 半角数字へ変換
      const toHalfWidth = (s) => s.replace(/[０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0));
      // 全角・半角数字をすべてマッチ
      const matches = str.match(/[0-9０-９]+/g);
      if (!matches) return '';
      // 各マッチを半角化し、連結して返す
      return matches.map(toHalfWidth).join('');
    },
    toBack() {
      this.$router.push('/edit/subscription/');
    },
    toNext() {
      const values = !this.flag.deliveried || this.cancelType === 'continue' ? this.initCancelValue : this.values;
      values.tel = this.replaceHalfWidthNum(values.tel);
      this.$emit('handleCancelData', values);
      this.$router.push('/edit/subscription/payment-method/');
    },
    changePlan(plan) {
      if (plan === 'webPaper') this.cancelType = 'cancel';
      this.$emit('changeCourse', plan);
    },
  },
};
</script>

<style lang="scss" module="s">

.stop_checkbox {
  text-align: center;
}
.stop_form {
  text-align: center;
}
.stop_label {
  font-size: 12px;
  padding-left: 4px;
  text-align: left;
  line-height: 1;
  font-weight: bold;
}
.stop_input {
  margin: 0 auto;
  width: 100%;
  max-width: 100%;
  position: relative;
  input {
    width: 100%;
    padding: 13px;
    border: none;
    background-color: var(--gray-sub);
    color: var(--black);
    outline: none;
    border-bottom: 1px solid var(--gray);
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;

    &:focus + .slideIn {
      display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(#e2e2e2, .4);
      mix-blend-mode: multiply;
      position: absolute;
      animation: split .3s;
    }

    @keyframes split {
      0% {
        width: 0;
      }
      100% {
        width: 100%;
      }
    }
  }
}
.radio {
  &_wrap {
    display: flex;
    flex-wrap: wrap;
  }

  margin-bottom: 4px;

  &:not(:last-child) {
    margin-right: 4px;
  }

  &_label {
    padding: 4px 12px;
    border-radius: 4px;
    border: 1px solid var(--lightgray);
    color: var(--gray);
    &.checked {
      border-color: var(--gray);
      color: var(--black);
    }
  }
  &_right {
    margin: 0 0 0 auto;
  }
}

.btns {
  margin-top: 24px;
}

.btn {
  display: block;
  padding: 4px 24px;
  border: 1px solid var(--black);
  border-radius: 50px;
  background-color: #ffffff;
  font-weight: bold;
  margin: 24px auto 0;
}

.cancel_options {
  display: flex;
  flex-direction: column;
  &.reverse {
    flex-direction: column-reverse;
  }
  > li {
    padding: 20px;
    border: 1px solid var(--border-gray);
    transition: all .3s;
    cursor: pointer;
    &:hover {
      background-color: #fff8f8;
    }
  }
  .cancel_radio {
    line-height: 1;
    font-weight: bold;
    > input {
      margin-right: 6px;
    }
  }
  .cancel_images {
    display: flex;
    align-items: stretch;
    margin-top: 16px;
    > * {
      display: flex;
      flex-direction: column;
      justify-content: center;
      &:not(:first-child) {
      margin-left: 12px;
      }
    }
    i { font-size: 30px; }

    .digital {
      display: flex;
      align-items: center;
      > i {
        font-size: 20px;
        padding: 12px;
      }
    }
  }

  .flex_column {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .plan {
    padding: 12px;
    background-color: var(--secondary-surface);
    border-radius: 6px;
  }
  .cancel_plan_label {
    margin-top: 6px;
    font-weight: bold;
  }
  .canceled {
    color: rgba(26, 34, 61, .5);
    > * {
      position: relative;
      &::after {
        content: '';
        width: 100%;
        border-bottom: 2px solid red;
        position: absolute;
        top: 50%;
        left: 0;
      }
    }
  }
  .cancel_payment {
    font-size: 12px;
  }
  .new_plan {
    display: flex;
    flex-direction: row;
    > * {
      margin-right: 6px;
    }
  }
  .note {
    margin-top: 12px;
  }

  .cancel_confirm {
    margin: auto 0;
    input {
      padding: 8px;
      border-radius: 0;
      outline: none;
      border: 1px solid var(--gray);
    }
  }
}

@include sm-view {
  .cancel_options {
    .cancel_images {
      flex-direction: column;
      align-items: center;
      > *:not(:first-child) {
        margin-left: 0;
      }
    }
    .plan {
      min-width: 120px;
    }
  }
  .cancel_arrow {
    rotate: 90deg;
    padding: 12px;
    transform-origin: center;
  }
}
</style>
